<div [ngStyle]="{'position': show ? 'fixed' : 'relative'}" class="logs-container">
  <table mat-table [dataSource]="lo" aria-label="Tabla de logs">
    <ng-container matColumnDef="numero">
      <th mat-header-cell *matHeaderCellDef> Número </th>
      <td mat-cell *matCellDef="let element"> {{element.id}} </td>
    </ng-container>
    <ng-container matColumnDef="Fecha">
      <th mat-header-cell *matHeaderCellDef> Fecha </th>
      <td mat-cell *matCellDef="let element"> {{element.Fecha}} </td>
    </ng-container>

    <ng-container matColumnDef="Maquina">
      <th mat-header-cell *matHeaderCellDef> Maquina </th>
      <td mat-cell *matCellDef="let element"> {{element.Maquina}} </td>
    </ng-container>

    <ng-container matColumnDef="Mensaje">
      <th mat-header-cell *matHeaderCellDef> Mensaje </th>
      <td mat-cell *matCellDef="let element"> {{element.Mensaje}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <mat-paginator [pageSizeOptions]="[10, 20, 50, 100, 150]" showFirstLastButtons></mat-paginator>
</div>

<div *ngIf="show" class="container-loading">
  <mat-spinner></mat-spinner>
</div>
